import { css, cx } from "@emotion/css";
import { resetStyles } from "@octopusdeploy/design-system-components";
import { borderRadius, colorScales, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
interface CategoryButtonProps {
    isActive: boolean;
    label: string;
    onClick: () => void;
}
export function CategoryButton({ label, isActive, onClick }: CategoryButtonProps) {
    return (<button type="button" className={cx(styles.button, isActive ? styles.active : styles.interactions)} onClick={onClick} tabIndex={isActive ? -1 : undefined}>
            {label}
        </button>);
}
const styles = {
    button: css({
        ...resetStyles.button,
        minWidth: "5rem",
        padding: space[8],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        font: text.body.bold.medium,
        borderRadius: borderRadius.small,
        color: themeTokens.color.button.text.secondary,
        background: themeTokens.color.button.background.secondary.default,
    }),
    interactions: css({
        ":hover": {
            background: themeTokens.color.button.background.secondary.hover,
        },
        ":focus-visible": {
            boxShadow: themeTokens.shadow.focused,
        },
        ":active": {
            background: themeTokens.color.button.background.secondary.pressed,
        },
    }),
    active: css({
        background: colorScales.blue[500],
        color: colorScales.white,
    }),
};
